import {
  Select as MuiSelect,
  MenuItem,
  SelectProps as MuiSelectProps,
  FormControl,
  InputLabel,
} from '@mui/material';
import { forwardRef } from 'react';

export interface SelectProps extends Omit<MuiSelectProps, 'variant'> {
  label?: string;
  options: { value: string; label: string }[];
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, options, ...props }, ref) => {
    return (
      <FormControl fullWidth size="small">
        {label && <InputLabel>{label}</InputLabel>}
        <MuiSelect ref={ref} variant="outlined" label={label} {...props}>
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </MuiSelect>
      </FormControl>
    );
  }
);

Select.displayName = 'Select';